import css from 'styled-jsx/css';

export default css`.articleCard {
  opacity: 0;
  cursor: pointer;
  margin: 15px 13px 0 0;
  background-color: #fff;
  overflow: hidden;
  float: left; }
  .articleCard.isLoaded, .articleCard:not(.masonry-article) {
    opacity: 1; }
  .articleCard.random-article {
    width: 100%;
    margin: 0 0 10px;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transition-duration: 0.4s;
    transition-property: opacity, transform;
    float: none; }
    .articleCard.random-article:nth-of-type(n + 1) {
      animation-delay: 0.1s; }
    .articleCard.random-article:nth-of-type(n + 2) {
      animation-delay: 0.2s; }
    .articleCard.random-article:nth-of-type(n + 3) {
      animation-delay: 0.3s; }
    .articleCard.random-article:nth-of-type(n + 4) {
      animation-delay: 0.4s; }
    .articleCard.random-article:nth-of-type(n + 5) {
      animation-delay: 0.5s; }
    .articleCard.random-article:nth-of-type(n + 6) {
      animation-delay: 0.6s; }
    .articleCard.random-article:nth-of-type(n + 7) {
      animation-delay: 0.7s; }
    .articleCard.random-article.zoomIn {
      animation-name: fadeInDown; }

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -10px, 0); }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0); } }
    .articleCard.random-article .articleCard-content {
      display: flex;
      flex-flow: row wrap;
      cursor: pointer;
      color: #58595b;
      transition: opacity 0.4s, transform 0.4s;
      padding: 15px; }
    .articleCard.random-article :global(.clamplines) {
      width: calc(100% - 95px);
      flex: 1 1 auto;
      margin: 0; }
    .articleCard.random-article :global(.title) {
      line-height: 2em;
      max-height: 2em;
      overflow: hidden;
      font-weight: 600;
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 2; }
    .articleCard.random-article:not(.isAD) :global(.title) {
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 1; }
    .articleCard.random-article :global(.des) {
      font-size: 0.9em;
      line-height: 1.5em;
      max-height: 4.5em;
      overflow: hidden;
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 3; }
    .articleCard.random-article :global(.title:empty ~ .des) {
      max-height: 6em;
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 4; }
    .articleCard.random-article :global(.articleCard-img) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 80px;
      margin-left: 15px; }
    .articleCard.random-article :global(.articleCard-img img) {
      margin: auto;
      width: 100%;
      height: 100%;
      object-fit: cover; }
    .articleCard.random-article .articleCard-child {
      padding: 15px 0 0; }
  .articleCard.masonry-article {
    min-width: 100%;
    margin: 0 0 15px;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transition-duration: 0.4s;
    transition-property: top, left, transform;
    will-change: top, left, transform;
    float: none; }
    .articleCard.masonry-article.zoomIn {
      animation-name: zoomIn;
      animation-delay: 0.3s; }

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3); }
  50% {
    opacity: 1; } }
    .articleCard.masonry-article :global(.clamplines:not(.secret)) {
      line-height: 22px;
      padding-top: 6px; }
      .articleCard.masonry-article :global(.clamplines:not(.secret)) :global(.clampline) {
        width: 100%;
        height: auto;
        color: rgba(0, 0, 0, 0.76);
        font-size: 0.85em;
        line-height: calc(1.4em + 3px);
        margin-bottom: 4px;
        font-weight: 600; }
    .articleCard.masonry-article :global(.articleCard-child *) {
      color: rgba(0, 0, 0, 0.68);
      font-weight: 400; }
  .articleCard.MobileCarousel :global(.articleCard-img),
  .articleCard.MobileCarousel :global(.articleCard-img img) {
    position: relative;
    width: 100%;
    height: 130px;
    object-fit: cover; }
  .articleCard.MobileCarousel :global(.clamplines) {
    width: calc(100% - 10px);
    color: #414141;
    padding-top: 10px;
    font-weight: 600; }
    .articleCard.MobileCarousel :global(.clamplines) :global(.clampline) {
      font-size: 0.95rem;
      line-height: 1.58em;
      margin-bottom: 5px; }
  .articleCard.MobileCarousel :global(.articleCard-child *) {
    color: #000;
    font-weight: 400; }
  .articleCard.PcCarousel {
    position: relative;
    margin: 0; }
    .articleCard.PcCarousel :global(.articleCard-img),
    .articleCard.PcCarousel :global(.articleCard-img img) {
      border-radius: 0;
      width: 100%;
      height: 100%;
      object-fit: cover; }
    .articleCard.PcCarousel :global(.articleCard-content) {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60%;
      padding: 15px 10px;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.5); }
    .articleCard.PcCarousel :global(.clamplines) {
      font-size: 1.3em;
      line-height: 1.5em; }
    .articleCard.PcCarousel :global(.articleCard-child) {
      display: none; }

.articleCard-content {
  padding: 0 10px; }

.articleCard-child {
  display: flex;
  position: relative;
  float: left;
  width: 100%;
  line-height: 22px;
  overflow: unset;
  padding: 6px 0 9px;
  margin: 0 auto; }
  .articleCard-child:only-child {
    margin-top: 10px; }

.articleCard-author {
  flex: 1;
  float: left;
  width: calc(100% - 3.5em); }

.articleCard-reply {
  margin-right: auto;
  color: #333333;
  font-size: 12px; }
`